module.exports = __webpack_public_path__ + "img/3m.a1439591.jpg";